/**
 * actions/app.ts
 * desc: global app actions
 * note: actions for global app state
 *
 */

export function setHasUnsavedChanges(payload: boolean) {
    return {
        type: 'SET_HAS_UNSAVED_CHANGES',
        payload,
    } as const;
}

export type AppAction = ReturnType<typeof setHasUnsavedChanges>;
